import type { Resource } from '../../';
export const product_details_artlabs_title: Resource = {"default":"Virtual Experience:"};
